import { render, staticRenderFns } from "./FormCreditProduct.vue?vue&type=template&id=89fa4428&"
import script from "./FormCreditProduct.vue?vue&type=script&lang=js&"
export * from "./FormCreditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports